import { formatDashboardNum, formatDashboardAmount } from './dashboardLeaseMock'

export { formatDashboardNum, formatDashboardAmount }

const channelTemplate = [
  { label: '直营销售收入', amount: 900000000, collected: 900000000, pending: 900000000 },
  { label: '经销商销售收入', amount: 900000000, collected: 900000000, pending: 900000000 },
  { label: '电商销售收入', amount: 900000000, collected: 900000000, pending: 900000000 },
  { label: '运维销售收入', amount: 900000000, collected: 900000000, pending: 900000000 },
]

const businessTemplate = [
  {
    label: '买断收入',
    amount: 900000000,
    units: 900000000,
    subs: null,
  },
  {
    label: '租赁收入',
    amount: 900000000,
    subs: [
      { label: '新增', amount: 900000000, units: 900000000 },
      { label: '续费', amount: 900000000, units: 900000000 },
    ],
  },
  {
    label: '流量收入',
    amount: 900000000,
    subs: [
      { label: '新增', amount: 900000000, units: 900000000 },
      { label: '续费', amount: 900000000, units: 900000000 },
    ],
  },
  {
    label: '服务包收入',
    amount: 900000000,
    subs: [
      { label: '新增', amount: 900000000, units: 900000000 },
      { label: '续费', amount: 900000000, units: 900000000 },
    ],
  },
]

function buildPeriod(channelSuffix, businessSuffix) {
  return {
    salesUnits: { value: 50000, mom: 80.12, momUp: true, yoy: -10.12, yoyUp: false },
    salesRevenue: {
      value: 2000000,
      mom: 80.12,
      momUp: true,
      yoy: -10.12,
      yoyUp: false,
      collected: 900000000,
      pending: 900000000,
    },
    categories: [
      { key: 'time', label: '时间型', units: 70000, amount: 900000000 },
      { key: 'traffic', label: '流量型', units: 70000, amount: 900000000 },
      { key: 'buyout', label: '买断型', units: 70000, amount: 900000000 },
    ],
    channelTitle: `按渠道分布${channelSuffix}`,
    businessTitle: `按业务分布${businessSuffix}`,
    byChannel: channelTemplate.map(x => ({ ...x })),
    byBusiness: businessTemplate.map(x => ({
      ...x,
      subs: x.subs ? x.subs.map(s => ({ ...s })) : null,
    })),
  }
}

export const performanceDashboardData = {
  annual: buildPeriod('（本年）', '（本年）'),
  monthly: buildPeriod('（本月）', '（本月）'),
}
